var map = {
	"./AmiyaBagchi.jpg": 626,
	"./AmiyaBagchi.png": 627,
	"./ChinmayTumbe.png": 628,
	"./DavidArnold.jpg": 629,
	"./DavidArnold.png": 630,
	"./DouglasHaynes.jpg": 631,
	"./DouglasHaynes.png": 632,
	"./DwijendraTripathi.jpg": 633,
	"./DwijendraTripathi.png": 634,
	"./GeoffreyJones.png": 635,
	"./IndiraChowdhury.jpg": 636,
	"./IndiraChowdhury.png": 637,
	"./JosephSassoon.jpg": 638,
	"./JosephSassoon.png": 639,
	"./MedhaKudaisya.jpg": 640,
	"./MedhaKudaisya.png": 641,
	"./MilanBalaban.png": 642,
	"./PrafullAnubhai.jpg": 643,
	"./PrafullAnubhai.png": 644,
	"./RamachandraGuha.png": 645,
	"./RituBirla.jpg": 646,
	"./RituBirla.png": 647,
	"./RobertPerks.png": 648,
	"./RossBassett.jpg": 649,
	"./RossBassett.png": 650,
	"./SusiePak.png": 651,
	"./SvenBeckert.png": 652,
	"./SvenBeckertOld.png": 653,
	"./TirthankarRoy.jpg": 654,
	"./TirthankarRoy.png": 655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 625;